export function ArrayData() {
    return {
        name: "array",
        label: "Array",
        primitiveType: "array",
        itemsType: "mixed",
    };
}

export default ArrayData;
